goog.provide("shadow.js.shim.module$date_fns$startOfDay$default");
shadow.js.shim.module$date_fns$startOfDay$default = shadow.js.require(215, {}).default;
